import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, alpha } from '@mui/material'

/**
 * Device status bar
 * Displays the current status with a corresponding color and icon
 */
const DeviceStatusBar = memo(({ statusConfig, statusText }) => {
  const { bg, text, icon: StatusIcon } = statusConfig

  return (
    <Box
      sx={{
        backgroundColor: bg,
        width: '100%',
        py: 0.75,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        transition: 'all 0.3s ease',
        borderBottom: `1px solid ${alpha(text, 0.2)}`,
        borderTop: `1px solid ${alpha(text, 0.1)}`
      }}
    >
      <StatusIcon sx={{ color: text, fontSize: '1.1rem' }} />
      <Typography
        variant='subtitle2'
        sx={{
          color: text,
          fontWeight: 700,
          letterSpacing: 1.5,
          fontSize: '0.75rem',
          textTransform: 'uppercase'
        }}
      >
        {statusText}
      </Typography>
    </Box>
  )
})

DeviceStatusBar.displayName = 'DeviceStatusBar'

DeviceStatusBar.propTypes = {
  statusConfig: PropTypes.shape({
    bg: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired
  }).isRequired,
  statusText: PropTypes.string.isRequired
}

export default DeviceStatusBar
